import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { config } from '@app/core/app-config';
import { HostInviteUser, InviteHostsService } from '@app/shared/services/invite-hosts/invite-hosts.service';

@Component({
  standalone: false,
  templateUrl: './connect-invite.component.html',
  styleUrls: ['./connect-invite.component.scss'],
})
export class ConnectInviteComponent implements OnInit {
  config = config;

  step: number = 1;

  // Step 2 - invitees
  invitees: HostInviteUser[] = [
    {
      name: '',
      email: '',
    },
  ];

  saving: boolean;

  scopeType?: 'pms' | 'ops';

  // Those get passed if invited for the specific channel
  platform?: string;
  platformId?: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly inviteHostsService: InviteHostsService,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (!params.platform || !params.platform_id) {
        this.scopeType = 'pms';

        return;
      }


      this.platform = params.platform;
      this.platformId = params.platform_id;
    });
  }

  sendInvites() {
    this.saving = true;

    this.inviteHostsService.sendInvites(this.invitees, this.platform, this.platformId, this.scopeType).subscribe(
      (res) => {
        if (res.success) {
          this.step = 4;
        }
      },
      (error) => {
        this.saving = false;
      }
    );
  }

  shouldShowScopeTypeSelection() {
    return ! this.platform || ! this.platformId;
  }
}
